import React, {
  useState,
  useEffect
} from 'react';

import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  Stepper,
  Step,
  StepLabel,
  Typography,
} from '@material-ui/core';

import lastStatus from '../../../utils/lastStatus';
import localization from '../../../utils/localizations';
import nl from '../../../utils/namespacedLocalizations';

import {
  History,
  StatusMapItem,
} from '../../../types';


const useStyles = makeStyles((theme) => ({
  mainBody: {
    padding: 10,
  },
}));


function CurrentStatus(props: {
  currentStatus: string;
  history: History[];
  statusMap: StatusMapItem[];
  namespace?: string;
}) {
  const classes = useStyles();
  const failingStatusList = ['rejected', 'approved_with_revision', 'presentation_required', 'closed', 'canceled'];
  const last = lastStatus(props.history);
  let lastNonRejectedStatus = lastStatus(props.history, failingStatusList, true);
  const currentNonRejectedStatus = lastNonRejectedStatus ? lastNonRejectedStatus.status : props.currentStatus;
  const isFailing = last && (failingStatusList.indexOf(last.status) > -1);
  
  let activeStep = 0;
  props.statusMap.forEach((item, i) => {
    if (item.status == currentNonRejectedStatus) {
      activeStep = i;
      if (item.status == 'accepted') activeStep += 1;
    }
  });

  return (
    <Stepper activeStep={activeStep}>
      {props.statusMap.map((item, i) => {
        let isError = false;
        let description = item.description;
        if ((activeStep > i) && item.descriptionCompleted) {
          description = item.descriptionCompleted;
        }
        if ((currentNonRejectedStatus == item.status) && last && isFailing) {
          isError = true;
          description = nl(last.status, props.namespace);
        }
        return (
          <Step>
            <StepLabel
              error={isError}
              optional={activeStep >= i ? (
                <Typography variant="caption" color={isError ? "error" : "inherit"}>{description}</Typography>
              ): null}
            >
              {item.label}
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
}

export {CurrentStatus};